export var NO_EXPIRY_DATE_STRING = '0000-00-00 00:00:00';